import React from 'react';
import styled from 'styled-components';
import { LinearProgress, Typography, CircularProgress } from '@mui/material';

const ProgressContainer = styled.div`
  padding: 30px;
  text-align: center;
`;

const ProgressBar = styled(LinearProgress)`
  margin: 20px 0;
  height: 10px;
  border-radius: 5px;
`;

const StatusText = styled(Typography)`
  margin-bottom: 10px;
  color: ${props => props.theme.colors.text};
`;

const PercentageText = styled(Typography)`
  margin-top: 10px;
  font-weight: bold;
  color: ${props => props.theme.colors.primary};
`;

function ImportProgress({ message, current, total, indeterminate = false }) {
  const percentage = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <ProgressContainer>
      {indeterminate ? (
        <>
          <CircularProgress size={60} />
          <StatusText variant="h6" style={{ marginTop: '20px' }}>
            {message}
          </StatusText>
        </>
      ) : (
        <>
          <StatusText variant="h6">{message}</StatusText>
          <ProgressBar variant="determinate" value={percentage} />
          <PercentageText variant="body1">
            {current} of {total} ({percentage}%)
          </PercentageText>
        </>
      )}
    </ProgressContainer>
  );
}

export default ImportProgress;
